import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { BackgroundJobDTO } from 'components/backgroundjobs/backgroundJobs';
import { isNullOrUndefined } from 'utils/Global';

export type systemTaskState = {
  backgroundJobs: BackgroundJobDTO[];
};

const initialState = { backgroundJobs: [] } as systemTaskState;

const backgroundJobSlice = createSlice({
  name: 'backgroundJobs',
  initialState,
  reducers: {
    addBackgroundJob: (state, action: PayloadAction<BackgroundJobDTO>): void => {
      state.backgroundJobs.push(action.payload);
    },
    setBackgroundJobs: (state, action: PayloadAction<BackgroundJobDTO[]>): void => {
      state.backgroundJobs = action.payload;
    },
    removeBackGroundJob: (
      state,
      action: PayloadAction<{ id: number; type: number }>,
    ): void => {
      state.backgroundJobs = state.backgroundJobs.filter(
        (t) => !(t.jobId == action.payload.id && t.jobType === action.payload.type),
      );
    },
    updateBackgroundJobProgress: (
      state,
      action: PayloadAction<{ jobId: number; progress?: number; name?: string }>,
    ): void => {
      const job = state.backgroundJobs.find((t) => t.jobId === action.payload.jobId);
      if (!isNullOrUndefined(job)) {
        if (action.payload.progress) {
          if (action.payload.progress == 100) {
            state.backgroundJobs = state.backgroundJobs.filter(
              (j) => j.jobId != job.jobId,
            );
          } else {
            job.progress = Math.ceil(action.payload.progress);
          }
        }
      }
    },
    removeCompletedBackgroundJob: (state): void => {
      state.backgroundJobs = state.backgroundJobs.filter((t) => t.progress != 100);
    },
  },
});

export const {
  addBackgroundJob,
  removeBackGroundJob,
  updateBackgroundJobProgress,
  removeCompletedBackgroundJob,
  setBackgroundJobs,
} = backgroundJobSlice.actions;

export default backgroundJobSlice.reducer;
